import { gql } from '@apollo/client';
import { EXPERT_QUEUE_FIELDS_FRAGMENT } from './expertQueueFieldsFragment.gql';

const EXPERT_QUEUE_CREATE_SUBSCRIPTION = gql`
  ${EXPERT_QUEUE_FIELDS_FRAGMENT}
  subscription onCreateExpertQueue($input: ExpertQueueSubscriptionFilterInput) {
    onCreateExpertQueue(input: $input) {
      ...ExpertQueueFields
    }
  }
`;

const EXPERT_QUEUE_UPDATE_SUBSCRIPTION = gql`
  ${EXPERT_QUEUE_FIELDS_FRAGMENT}
  subscription onUpdateExpertQueue($input: ExpertQueueSubscriptionFilterInput) {
    onUpdateExpertQueue(input: $input) {
      ...ExpertQueueFields
    }
  }
`;

const EXPERT_QUEUE_ENTER_SUBSCRIPTION = gql`
  ${EXPERT_QUEUE_FIELDS_FRAGMENT}
  subscription onEnterExpertQueue($input: ExpertQueueSubscriptionFilterInput) {
    onEnterExpertQueue(input: $input) {
      ...ExpertQueueFields
    }
  }
`;

const EXPERT_QUEUE_LEAVE_SUBSCRIPTION = gql`
  ${EXPERT_QUEUE_FIELDS_FRAGMENT}
  subscription onLeaveExpertQueue($input: ExpertQueueSubscriptionFilterInput) {
    onLeaveExpertQueue(input: $input) {
      ...ExpertQueueFields
    }
  }
`;

export {
  EXPERT_QUEUE_CREATE_SUBSCRIPTION,
  EXPERT_QUEUE_UPDATE_SUBSCRIPTION,
  EXPERT_QUEUE_ENTER_SUBSCRIPTION,
  EXPERT_QUEUE_LEAVE_SUBSCRIPTION,
};
